import { TService } from '@/features/product-services/lib/types'

export const getCheapestPrices = (arr: TService[]) => {
	const cheapestPrices: number[] = []

	arr.forEach(obj => {
		if (obj.VARIANTS && obj.VARIANTS.length > 0) {
			// Находим минимальную цену в подмассиве "VARIANTS"
			const minPrice = Math.min(...obj.VARIANTS.map(item => item.PRICE))

			// Добавляем минимальную цену в массив cheapestPrices
			cheapestPrices.push(minPrice)
		}
	})

	return cheapestPrices
}
